import Toolkit from '../utils/utils';
import Anim from '../utils/doAnim';
let myself = Toolkit.myself;

function footer() {
    let footer = new Anim($(".footer-div"), myself.slideUpIn);
    $(window).scroll(() => {
        footer.doit();
    });
}

module.exports = footer;


// WEBPACK FOOTER //
// ./js/page/footer.js